"use client"

import { ListChevronsUpDown } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ListChevronsUpDownIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ListChevronsUpDownIcon = component(Icon)({
  as: ListChevronsUpDown,
})
